import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import CompareItem from './CompareItem';
import CloseIcon from '../Icons/CloseIcon';

function CompareView({
  selectedIDs,
  toggleWorkspaceDetailView,
  dispatch,
  retrieveUMOs,
}) {
  return (
    <div className="compare-umos-view">
      <CloseIcon
        width={32}
        height={32}
        aria-label="Close"
        onClick={() => toggleWorkspaceDetailView(false)}
        className="compare-umos-view__close-icon"
      />
      <div className="compare-umos__columns col-sm-12">
        {selectedIDs.map(umoID =>
          <CompareItem
            key={umoID}
            umoID={umoID}
            dispatch={dispatch}
            retrieveUMOs={retrieveUMOs}
            toggleWorkspaceDetailView={toggleWorkspaceDetailView}
            displayTwo={selectedIDs.size === 2}
          />)}
      </div>
    </div>);
}

CompareView.propTypes = {
  selectedIDs: PropTypes.instanceOf(List),
  toggleWorkspaceDetailView: PropTypes.func,
  dispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
};

export default CompareView;
